import { render, staticRenderFns } from "./tw_footer.vue?vue&type=template&id=eae5ba84&scoped=true&"
import script from "./tw_footer.vue?vue&type=script&lang=js&"
export * from "./tw_footer.vue?vue&type=script&lang=js&"
import style0 from "./tw_footer.vue?vue&type=style&index=0&id=eae5ba84&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eae5ba84",
  null
  
)

export default component.exports